import fastpanel from './fastpanel';

// a simple wrapper/adapter function, replace whatever
// you want in the interior, here we are still using fastpanel

function trackingFunction(event: TrackedEvent): void {
  fastpanel(event);
}

export default trackingFunction;
